import React, { useEffect } from "react";

import { lead } from "../../../utils/constants";
import { LazyLoadImage } from "react-lazy-load-image-component";

const Milktheframer = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <section
        className={`bg-black px-8 pt-40 md:pt-60 -mt-[1px] text-center  lg:px-16 md:pb-10`}
      >
        <div className=" md:w-[80%] pb-12 text-left ">
          <h2
            className={`text-[32px] md:text-[64px] text-white leading-[33px] lg:leading-[74.56px] font-semibold `}
          >
            LEAD4CHANGE-
          </h2>
          <p
            className={`text-[32px] md:text-[64px] text-white leading-[33px] lg:leading-[74.56px]`}
          >
            Full Brand Design for Non-Governmental Organisation
          </p>
        </div>
      </section>

      <section className="bg-black px-8 pb-12  -mt-[1px] lg:px-16 lg:pb-16">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="space-y-4 text-white">
            <h1 className="font-[400] text-[20px] leading-[30px] text-white/50 ">
              ABSTRACT
            </h1>
            <div className="h-[0.5px] bg-[#f5f5f5]" />
            <p className="font-[400] text-[20px] leading-[30px] ">
              An N.G.O aiming at making relevant change in and out of Africa
              required visual representations for their brand - so I made
              something endearing and remarkable.
            </p>
          </div>

          <div className="space-y-4 text-white">
            <h1 className="font-[400] text-[20px] leading-[30px] text-white/50 ">
              SERVICE
            </h1>
            <div className="h-[0.5px] bg-[#f5f5f5]" />
            <p className="font-[400] text-[20px] leading-[30px] ">
              Brand Design
            </p>
          </div>

          <div className="space-y-4 text-white">
            <h1 className="font-[400] text-[20px] leading-[30px] text-white/50 ">
              CREDITS
            </h1>
            <div className="h-[0.5px] bg-[#f5f5f5]" />
            <p className="font-[400] text-[20px] leading-[30px] ">
              Art Direction: Temidayo Arowolo <br />
              Collaborator: Daniel Owolabi
            </p>
          </div>
        </div>
      </section>

      <section className="bg-black px-8  -mt-[1px] lg:px-16 md:pb-10">
        {lead.map((image) => (
          <div key={image.id} className="">
            <LazyLoadImage
              src={image.img}
              effect="blur"
              className="w-full pb-4"
              alt={image.id}
            />
          </div>
        ))}
      </section>

      <div className="bg-black px-8  -mt-[1px] lg:px-16 md:pb-10">
        <div className="h-[0.5px] bg-[#f5f5f5]" />
      </div>
    </>
  );
};

export default Milktheframer;
